<div id="organizationRiderDetail-div-riderIneligibleMsg" class="ineligible-rider" *ngIf="riderIneligibleForOrganization">
  <mat-icon class="material-icons-outlined">error</mat-icon>
  Rider is currently ineligible for one or more organizations. Please see below.
</div>

<div class="rider-details" *ngIf="organizationRiderDetail$ | async as organizationRiderDetail">
  <ng-container *ngIf="!(isLoadingRiderDetails$ | async) as notLoading, else loading">
    <ng-container *ngIf="getUzurvRiderFullName$ | async  as uzurvRiderFullName ">
      <mat-card appearance="outlined">
        <mat-card-header class="spacer">
          <mat-icon mat-card-avatar class="material-icons-two-tone">face</mat-icon>
          <mat-card-title
            id="organizationRiderDetail-text-firstNameLastName"
            data-private
            *appRequiresPermissions="{any: ['rider_management']}"
          >
            {{uzurvRiderFullName}}
          </mat-card-title>
          <mat-card-subtitle>
            <span class="subtitle-section">
              <span
                id="organizationRiderDetail-text-balance"
                [ngClass]="organizationRiderDetail.balance > 0 ? 'balance negative' : 'balance'"
              >
                Balance: {{ organizationRiderDetail.balance | currency }}
              </span>
            </span>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-tab-group
            [selectedIndex]="selectedTabIndex$ | async"
            (selectedTabChange)="handleSelectedTabChange($event?.index)"
            mat-stretch-tabs="false"
            dynamicHeight
          >
            <mat-tab label="Basic Info" class="disable-overflow">
              <div>
                <ng-container *appRequiresPermissions="{any: ['rider_read']}">
                  <ng-container *ngIf="uzurvRiderProfile$ | async as uzurvRiderProfile">
                    <app-uzurv-rider-profile
                      [rider]="uzurvRiderProfile"
                      [riderAddress]="organizationRiderAddress$ | async"
                      [isSendingUzurvRideAppInvitation]="isSendingUzurvRideAppInvitation$ | async"
                      [isOrganizationRiderAppEnabled]="isOrganizationRiderAppEnabled$ | async"
                      (editRiderButtonClicked)="handleEditUzurvRider()"
                      (sendUzurvRideAppInvitation)="handleSendUzurvRideAppInvitation(organizationRiderDetail)"
                    ></app-uzurv-rider-profile>
                  </ng-container>
                </ng-container>
                <ng-container *appRequiresPermissions="{any: ['organization_rider_read']}">
                  <app-organization-rider-profile
                    *ngFor="let organizationRiderDetail of organizationRiderDetails$ | async"
                    [organizationRiderDetail]="organizationRiderDetail"
                    (editOrganizationRiderInfo)="handleEditOrganizationRider($event)"
                    (eligibilityToggleChanged)="handleEligibilityToggle(organizationRiderDetail, $event )"
                  ></app-organization-rider-profile>
                </ng-container>
              </div>
              <button
                mat-button
                id="organizationRiderDetail-add-organization-button"
                (click)="handleAddOrganizationRider()"
                *appRequiresPermissions="{any: ['organization_rider_create']}"
              >
                <mat-icon>add</mat-icon>
                Add Organization
              </button>
            </mat-tab>

            <mat-tab id="rider-tab-rides" label="Rides">
              <div class="tab-content">
                <app-rider-ride-history
                  [trips]="riderTrips$ | async"
                  [pageIndex]="tripsPageIndex$ | async"
                  [pageSize]="tripsPageSize$ | async"
                  (paginate)="handleTripsPaginate($event)"
                  (goToTrip)="handleGoToTrip($event)"
                >
                </app-rider-ride-history>
              </div>
            </mat-tab>

            <mat-tab label="Internal Notes" *appRequiresPermissions="{any: ['customer_service_note_read']}">
              <app-organization-rider-notes-detail [customerServiceNotes]="customerServiceNotes$ | async" (addNote)="handleAddNote($event)">
              </app-organization-rider-notes-detail>
            </mat-tab>
            <mat-tab label="Favorite Drivers">
              <ng-container *ngIf="getFavoriteDrivers$ | async as favoriteDrivers">
                <div class="rider-tab-body">
                  <p id="organizationRiderDetail-label-noFavoriteDrivers" *ngIf="!favoriteDrivers || favoriteDrivers.length === 0">
                    No Favorite Drivers
                  </p>

                  <mat-list>
                    <app-favorite-drivers-list-item
                      id="organizationRiderDetail-listItem-favoriteDriver-{{driver.id}}"
                      *ngFor="let driver of favoriteDrivers"
                      [driver]="driver"
                      (deleteDriver)="handleDeleteFavoriteDriver($event)"
                    >
                    </app-favorite-drivers-list-item>
                  </mat-list>
                </div>
              </ng-container>
            </mat-tab>
            <mat-tab label="Ignored Drivers">
              <ng-container *ngIf="ignoredDrivers$ | async as ignoredDrivers">
                <div class="rider-tab-body">
                  <p id="organizationRiderDetail-label-noIgnoredDrivers" *ngIf="ignoredDrivers?.length === 0">No Ignored Drivers</p>
                  <mat-list>
                    <app-ignored-drivers-list-item
                      id="organizationRiderDetail-listItem-ignoredDriver-{{driver.id}}"
                      *ngFor="let driver of ignoredDrivers"
                      [driver]="driver"
                      (deleteDriver)="handleDeleteIgnoredDriver($event)"
                    >
                    </app-ignored-drivers-list-item>
                  </mat-list>
                </div>
              </ng-container>
            </mat-tab>
            <mat-tab *ngIf="showPaymentTabs" label="Manage Payment Accounts">
              <div class="rider-tab-body payment-accounts-add-payment">
                <div class="payment-account-container">
                  <div class="payment-accounts">
                    <app-payment-account-details
                      id="organizationRiderDetail-card-{{account.id}}"
                      *ngFor="let account of riderPaymentAccounts$ | async"
                      [paymentAccount]="account"
                      (click)="handleOpenEditPaymentAccount(account)"
                      (edit)="handleOpenEditPaymentAccount($event)"
                    >
                    </app-payment-account-details>
                    <div class="add-payment-account" *appRequiresPermissions="{any: ['organization_rider_update'] }">
                      <button
                        id="organizationRiderDetail-button-addPaymentAccount"
                        class="add-payment-account-button"
                        mat-stroked-button
                        color="primary"
                        (click)="handleAddPaymentAccount()"
                      >
                        <mat-icon>add</mat-icon>&nbsp;Add Card
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <ng-container *appRequiresPermissions="{any: ['payment_processing']}">
              <ng-container *ngIf="showPaymentTabs">
                <mat-tab label="Payments">
                  <div class="rider-tab-body">
                    <app-collect-payment
                      *ngIf="organizationRiderDetail.balance > 0"
                      [paymentAccounts]="riderPaymentAccounts$ | async"
                      [outstandingCharges]="outstandingCharges$ | async"
                      (editPaymentAccount)="handleOpenEditPaymentAccount($event)"
                      (submitPayment)="handleSubmitPaymentForOutstandingCharges($event)"
                    >
                    </app-collect-payment>

                    <app-payment-history
                      [payments]="payments$ | async"
                      [paymentAccounts]="riderPaymentAccounts$ |async"
                      [expandedPayment]="expandedPayment$ | async"
                      [expandedPaymentTransactions]="expandedPaymentTransactions$ | async"
                      [loadingTransactions]="loadingTransactions$ | async"
                      (pageListClicked)="handlePagePaymentsList($event)"
                      (editPaymentAccount)="handleOpenEditPaymentAccount($event)"
                      (newPayment)="handeOpenNewPaymentDialog()"
                      (voidPayment)="handleVoidPayment($event)"
                      (resubmitPayment)="handleResubmitPayment($event)"
                      (expandPayment)="handleExpandPayment($event)"
                      (refundPayment)="handleOpenRefundDialog($event)"
                    >
                    </app-payment-history>
                  </div>
                </mat-tab>
              </ng-container>
            </ng-container>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </ng-container>

    <ng-container *ngIf="riderNotFound">
      <div class="no-rider-found">
        <mat-icon>face</mat-icon>
        <h1>Rider Not Found</h1>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <mat-spinner class="spinner"></mat-spinner>
  </ng-template>
</div>
